import React from "react";
import { Row, Col, Form } from "react-bootstrap";
import GenerationsSelect from "../../select/generation";

class Name extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            label: props.label
        }
    }
    

    render() {
        return (<>
            <Row className="g-3">
                <Col lg="12">
                    <h2 className="small-title">{this.state.label}</h2>
                </Col>
            </Row>
                
        </>)
    }
}

export default Name;